module.exports = __webpack_public_path__ + "img/deals-active.8ff0a965.svg";